import 'normalize.css'
import '@/styles/app.scss'
// import 'core-js/shim'
import 'intersection-observer'

import axios from 'axios'
import device from 'current-device'
import DetectInApp from 'detect-inapp'

import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import App from '@/App'
import router from '@/router'
import ga from '@/scripts/ga'

import SvgSymbol from '@/components/SvgSymbol'
import inviewDirective from '@/directives/inview'
import ellipsisFilter from '@/filters/ellipsis'
import numericFilter from '@/filters/numeric'
import percentageFilter from '@/filters/percentage'

Vue.config.productionTip = false

// In order to prevent the browser's default behavior
// [issue] https://github.com/quasarframework/quasar/issues/1466#issuecomment-414066098
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

Vue.use(VueScrollTo)

Vue.device = Vue.prototype.$device = device
Vue.inApp = Vue.prototype.$inApp = new DetectInApp(window.navigator.userAgent)
Vue.http = Vue.prototype.$http = axios
Vue.ga = Vue.prototype.$ga = ga
Vue.bus = Vue.prototype.$bus = new Vue()

Vue.component('SvgSymbol', SvgSymbol)
Vue.directive('inview', inviewDirective)
Vue.filter('ellipsis', ellipsisFilter)
Vue.filter('numeric', numericFilter)
Vue.filter('percentage', percentageFilter)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
